import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import {
  onChangePassword,
  onUserSettingPreference,
  onUserUpdateSettingPreference,
} from "../../../redux/homeAction";
import Banner from "../../Banner/Banner";
import Footer from "../../Footer/Footer";
import Loader from "../../loader/Loader";
import Navbar from "../../Navbar/Navbar";
import Profile from "../Profile/Profile";

const Setting = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(1);
  const [value, setValue] = useState({});
  const [preferenceId, setPreferenceId] = useState([]);
  const [loader, setLoader] = useState(false);
  const [addClass, setAddClass] = useState(false);
  const getUserSettingPreference = useSelector(
    (state) => state.home.getUserSettingPreference
  );
  const getUserUpdateSettingPreference = useSelector(
    (state) => state.home.getUserUpdateSettingPreference
  );
  const userDeatils = JSON.parse(localStorage.getItem("userDetails"));

  useEffect(() => {
    const data = {
      user_id: userDeatils && userDeatils.user_id,
    };
    dispatch(onUserSettingPreference(data));
  }, [getUserUpdateSettingPreference]);

  const inputHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };

  const changePassword = (e) => {
    e.preventDefault();
    if (!value.oldPassword) {
      toast.error("please enter current password");
    } else if (!value.newPassword) {
      toast.error("please enter new password");
    } else if (!value.confirmPassword) {
      toast.error("please enter confirm password");
    } else if (value.newPassword !== value.confirmPassword) {
      toast.error("Password and confirm password should match");
    } else if (value.newPassword.length < 8) {
      toast.error("Password must be at least 8 characters long");
    } else {
      const data = {
        current_password: value.oldPassword,
        password: value.newPassword,
        password_confirmation: value.confirmPassword
      };
      dispatch(onChangePassword(data));
    }
  };
  const classSend = "position-relative";

  const checkEvnetHandler = (id) => {
    let updateList = [...preferenceId];
    if (id.event.target.checked) {
      updateList = [...preferenceId, id.id];
    } else {
      updateList.splice(preferenceId.indexOf(id.id), 1);
    }
    setPreferenceId(updateList);
  };

  const changeUserSetting = () => {
    setLoader(true);
    const data = {
      preferences_sub_category_id:
        preferenceId.length === 0 ? "0," : preferenceId.join(),
      user_id: userDeatils && userDeatils.user_id,
    };

    dispatch(onUserUpdateSettingPreference(data, setLoader));
  };

  return (
    <>
      <Navbar classSend={classSend} />
      <Profile />
      <section id="Tabs_section">
        <div className="container">
          <div className="tabs_container">
            <div className="tabs_nav">
              <ul id="tabs">
                {/* <li>
                  <div>
                    <NavLink to="/dashboard-profile">Wall</NavLink>
                  </div>
                </li>
                <li>
                  <div>
                    <NavLink to="/dashboard-notification">notification</NavLink>
                  </div>
                </li>
                <li>
                  <div>
                    <NavLink to="/dashboard-my-wallet">my wallet</NavLink>
                  </div>
                </li>*/}
                <li>
                  <div>
                    <NavLink to="/dashboard-edit-profile">edit profile</NavLink>
                  </div>
                </li>
                {/* <li>
                  <div>
                    <NavLink to="/dashboard-friend-referrelas">
                      friends &amp; referrelas
                    </NavLink>
                  </div>
                </li> */}
                <li className={`${addClass ? "active_tab" : ""} `}>
                  <div>
                    <NavLink
                      to="/dashboard-setting"
                      className={({ isActive }) => {
                        setAddClass(isActive);
                      }}
                    >
                      change password
                    </NavLink>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="tebs_content">
            <div className="tabs_section" id="settings">
              <div className="theWall">
                <h1>Preferences</h1>
                <div className="bats_nav">
                  <ul id="Setting_tabs">
                    {/*<li
                      className={`${show === 0 ? "active_bat" : ""}`}
                      onClick={() => setShow(0)}
                      style={{ cursor: "pointer" }}
                    >
                      <div>
                        <a>Preferences</a>
                      </div>
                    </li> */}
                    <li
                      className={`${show === 1 ? "active_bat" : ""}`}
                      onClick={() => setShow(1)}
                      style={{ cursor: "pointer" }}
                    >
                      <div>
                        <a>Change Password</a>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bets_section">
                  <div className="Setting_content">
                    <div className="preference_container">
                      <div className="form_container">
                        <form onSubmit={changePassword}>
                          <div className="row g-5">
                            <div className="col-md-6">
                              <input
                                type="password"
                                className="input"
                                placeholder="Current Password"
                                name="oldPassword"
                                onChange={(e) => inputHandler(e)}
                                value={value.oldPassword}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="password"
                                className="input"
                                placeholder="New Password"
                                name="newPassword"
                                onChange={(e) => inputHandler(e)}
                                value={value.newPassword}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="password"
                                className="input"
                                placeholder="Confirm Password"
                                name="confirmPassword"
                                onChange={(e) => inputHandler(e)}
                                value={value.confirmPassword}
                              />
                            </div>
                          </div>
                          <input
                            type="submit"
                            className="btn post_btn btnFill smallbtn mt-4 mb-4"
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <Banner />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Setting;
